/**
 * XL Landing Header - Interactive gallery.
 * Adapted from single-pdp.js (gallery + thumbs + touch swipe).
 * Supports multiple section instances on one page.
 */
(function () {
  'use strict';

  function initSection(section) {
    var track = section.querySelector('[data-xlh-track]');
    var slides = section.querySelectorAll('[data-xlh-slide]');
    var thumbs = section.querySelectorAll('[data-xlh-thumb]');
    var prevBtn = section.querySelector('[data-xlh-prev]');
    var nextBtn = section.querySelector('[data-xlh-next]');
    var main = section.querySelector('[data-xlh-main]');
    var total = slides.length;
    var current = 0;

    if (total === 0 || !track) return;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
      });

      var activeThumb = thumbs[current];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-xlh-thumb'), 10));
      });
    });

    if (main) {
      var startX = 0;
      main.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.xlh').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor adds/reloads the section
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.xlh');
    if (section) initSection(section);
  });
})();
